import { PageStructure, SitemapNode, SitemapStructure } from './sitemap-types';

/**
 * Преобразует массив страниц в древовидную стуктуру
 * @param {PageStructure} pageList 
 * @returns {SitemapStructure[]}
 */
export const buildSitemapTree = (pageList: PageStructure[]): SitemapStructure => {
  const nodeTree: Record<string, SitemapNode> = {};
  const result: SitemapStructure = [];

  pageList.forEach((page: PageStructure) => {
    nodeTree[page.pageUrl] = {
      ...page,
      children: [],
    }
  });

  pageList.forEach((page: PageStructure) => {
    const node = nodeTree[page.pageUrl];
    if (page.parentPageUrl === '/') {
      result.push(node);
    } else {
      if (nodeTree[page.parentPageUrl]) {
        nodeTree[page.parentPageUrl].children.push(node);
      }
    }
  })

  return result;
};
